// 宿舍模块路由
export default [
  {
    path: '/dormManagement',
    component: resolve => require(['@/pages/dorm/dormManagement.vue'], resolve),
    name: 'dormManagement',
    meta: {
      title: '宿舍管理'
    }
  },
  {
    path: '/knowingAKey',
    component: resolve => require(['@/pages/dorm/knowingAKey.vue'], resolve),
    name: 'knowingAKey',
    meta: {
      title: '寝室出入异常数据'
    }
  },
  {
    path: '/dorm/access-statistics',
    component: resolve => require(['@/pages/dorm/access-statistics/index.vue'], resolve),
    name: 'access-statistics',
    meta: {
      title: '宿舍出入统计'
    }
  },
  {
    path: '/dorm/statistics',
    component: resolve => require(['@/pages/dorm/dorm-statistics/index.vue'], resolve),
    name: 'statistics',
    meta: {
      title: '宿舍统计'
    }
  },
  {
    path: '/dorm/dormitoryStatistics',
    component: resolve => require(['@/pages/dorm/dormitoryStatistics/index.vue'], resolve),
    name: 'dormitoryStatistics',
    meta: {
      title: '宿舍统计图'
    }
  },
  {
    path: '/dorm/dormDivision',
    component: resolve => require(['@/pages/dorm/dormDivision.vue'], resolve),
    name: 'dormDivision',
    meta: {
      title: '寝室划分'
    }
  },
  {
    path: '/dormAbnormal',
    component: resolve => require(['@/pages/dorm/dormAbnormal'], resolve),
    name: 'dormAbnormal',
    meta: {
      title: '一键查寝'
    }
  },
  {
    path: '/dorm/divisionManagement',
    component: resolve => require(['@/pages/dorm/dormDivisionManagement'], resolve),
    name: 'dormDivisionManagement',
    meta: {
      title: '寝室划分管理'
    }
  },
  {
    path: '/dorm/studentTransferRecord',
    component: resolve => require(['@/pages/dorm/dormTransferRecord'], resolve),
    name: 'dormTransferRecord',
    meta: {
      title: '寝室入退换记录'
    }
  },
  {
    path: '/dorm/dormProcess',
    component: resolve => require(['@/pages/dorm/dormProcess'], resolve),
    name: 'dormProcess',
    meta: {
      title: '寝室入退换权限配置'
    }
  },
  {
    path: '/dorm/dormDetermine',
    component: resolve => require(['@/pages/dorm/dormDetermine'], resolve),
    name: 'dormDetermine',
    meta: {
      title: '寝室信息确认'
    }
  },
  {
    path: '/dorm/dormDetermineDetail',
    component: resolve => require(['@/pages/dorm/dormDetermineDetail'], resolve),
    name: 'dormDetermine',
    meta: {
      title: '寝室信息确认详情'
    }
  },
  {
    path: '/dorm/dormRecords',
    component: resolve => require(['@/pages/dorm/dormRecords'], resolve),
    name: 'dormRecords',
    meta: {
      title: '入退换日志'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/dorm.js